import { GroupByUser, Member } from "../models/members/member";
import { Status } from "../util/enums";
import BaseService from "./_base.service";
import API from "../api";
import { AxiosResponse } from "axios";
import { MemberUser } from "../models/members/member.user";
import { MemberStaff, MemberStaffWithoutTimezoneId } from "../models/members/member.staff";
import { AllowArrayInCompanyId } from "../util/allowArrayInCompanyId";

const endpoint = "members";


const MembersService = {
  ...BaseService<AllowArrayInCompanyId<Member>, Member>({ endpoint }),
  async changeStatus(id: number, status: Status): Promise<AxiosResponse<boolean>> {
    return await API.put(`${endpoint}/change/status/${id}`, { status });
  },
  async updateMember(
    id: number,
    member: MemberUser | MemberStaff
  ): Promise<AxiosResponse<boolean>> {
    return await API.put(`${endpoint}/${id}`, { typeOfMember: member?.typeOfMember, member });
  },
  async createMember(member: MemberUser | MemberStaff): Promise<AxiosResponse<boolean>> {
    return await API.post(`${endpoint}`, { typeOfMember: member?.typeOfMember, member });
  },
  async postCSV(data: MemberStaffWithoutTimezoneId[]): Promise<AxiosResponse<Member[]>> {
    return await API.post(`/${endpoint}/upload/create/list`, data);
  },
  async getGroupByUser(userId: number, companyId: number): Promise<AxiosResponse<GroupByUser[]>> {
    return await API.get(`/group-users/groups-by-user`, { params: { userId, companyId } });
  },
  async resendWelcomeEmail(userId: number): Promise<AxiosResponse<boolean>> {
    return await API.post(`/users/resend/welcome-email/${userId}`);
  },
};

export default MembersService;
